import styled from 'styled-components';

export const CommentScrollBox = styled.div.attrs({
  className: 'scroll-box' // for scroll bar styles
})`
  background-color: ${({ theme }) => theme.colors.colorPureWhite};
  padding-bottom: 60px;
`;
